import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./InternalK1PullDataModal.module.css";
import { Accordion, Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { ColDef, GridReadyEvent, themeQuartz } from "ag-grid-community";
import { getFromLS } from "utils/storage";
import dayjs from "dayjs";
import { ICellRendererParams } from 'ag-grid-community';
import { CustomButton } from "reusable-components/CustomButtonComponent/button";
import { theme } from "highcharts";
import {  themeBalham } from 'ag-grid-community'; // or themeQuartzDark
import CygnusGrid from "pages/CygnusGrid/CygnusGrid";


export interface InternalK1ParentData {
  SourceName: string;
  DocumentId: string;
  ClientMasterId: string;
  ParentClientMasterId: string;
}
interface InternalK1PullDataModalProps {
  show: boolean;
  onHide: () => void;
  onSelectComplete: (id: string) => void;
  ssnoreinofclient: string; // or number, depending on your data
  refresh: () => void;
  selectedParent?: InternalK1ParentData | null;
  selectedReturnIdFromInternalK1: any;
}
interface PartnershipInfo {
  name: string;
  ein: string;
  returnId: string;
}

interface Partner {
  id: string;
  name: string;
  ssn: string;
  entity_type: string;
  return_id_options: string[];
  selected: boolean;
  selectedReturn: string;
  selectedOutputVersion?: string;
  status: string;
  statusMessage?: string;
}

interface ParentModeState {
  ein: string;
  partnershipInfo: PartnershipInfo;
  partners: Partner[];
  childReturnVersion: string;
  childOutputVersion: string;
  childReturnOptions: string[];
}

interface FlowHistoryItem {
  timestamp: string;
  partnership_name: string;
  partnership_return_id: string;
  partner_name: string;
  partner_return_id: string;
  dest_version: string;
  status: string;
  message: string;
}

interface FlowHistoryResponse {
  status: string;
  data: FlowHistoryItem[];
}

interface PartnerStatus {
  status: string;
  message?: string;
}

interface BatchStatusResponse {
  status: string;
  partners?: Record<string, PartnerStatus>;
  parents?: Record<string, PartnerStatus>;
}


interface ParentReturnIdResponse {
  "Name": string,
  "ReturnId": string,
  "ReturnStatus": string,
  "ReturnLastUpdatedDate": string
}

/**
 * InternalK1PullDataModal Component
 */

const API_URL = process.env.REACT_APP_INTERNAL_K1_BASE_URL;
const BACKEND_URL = process.env.REACT_APP_TAX_URI;

const InternalK1PullDataModal: React.FC<InternalK1PullDataModalProps> = ({
  show,
  onHide,
  onSelectComplete,
  ssnoreinofclient,
  refresh,
  selectedParent,
  selectedReturnIdFromInternalK1
}) => {

  const [isFetchParent, setIsFetchParent] = useState<boolean>(true);
  const [status, setStatus] = useState<string[]>([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState<boolean>(false);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [history, setHistory] = useState<FlowHistoryItem[]>([]);
  const [batchId, setBatchId] = useState<string | null>(null);
  const [ein, setEin] = useState(ssnoreinofclient);
  const [refreshGrid, setRefreshGrid] = useState(false);

  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  const [parentReturnIds, setParentReturnIds] = useState<ParentReturnIdResponse[]>([]);

  const [parentModeState, setParentModeState] = useState<ParentModeState>({
    ein: '',
    partnershipInfo: { name: "", ein: "", returnId: "" },
    partners: [],
    childReturnVersion: '',
    childOutputVersion: 'Same',
    childReturnOptions: []
  });

  const [selectedReturnId, setSelectedReturnId] = useState<string | null>(null);

  const gridStyle = {
    width: '100%',
    border: '1px solid #dee2e6',
    borderRadius: '4px',
    height: "53vh"
  };

  const gridRef = useRef<any>(null);

  const columnDefs: ColDef[] = [
    { headerName: 'ReturnId', field: 'ReturnId', flex: 1 },
    {
      headerName: 'Status',
      field: 'ReturnStatus',
      flex: 1,
    },
    {
      headerName: 'Last Updated', field: 'ReturnLastUpdatedDate', flex: 1,
      cellRenderer: (params: ICellRendererParams) => {
        return formatTimestamp(params.value);
      }

    },
  ];

  const [key, setKey] = useState<number | undefined>(undefined);  

  useEffect(() => {
    handleGetTableData();
  }, [ssnoreinofclient])

  // useEffect(() => {
  //   if (selectedReturnIdFromInternalK1 && gridRef.current && parentReturnIds.length > 0 && selectedParent) {
  //     console.log("INSIDE", selectedReturnIdFromInternalK1[selectedParent?.DocumentId])
  //     gridRef?.current?.api?.forEachNode((node: any) => {
  //       console.log(node.data?.ReturnId, ' ---', selectedReturnIdFromInternalK1[selectedParent?.DocumentId])
  //       if (node.data?.ReturnId == selectedReturnIdFromInternalK1[selectedParent?.DocumentId]) {
  //         console.log("ick")
  //         node.setSelected(true);
  //       }
  //     });
  //   }
  // }, [parentReturnIds, selectedReturnIdFromInternalK1]);

  const updateCurrentState = (updates: Partial<ParentModeState>) => {
    if (isFetchParent) {
      setParentModeState(prev => ({ ...prev, ...updates }));
    }
  };

  const setPartners = (value: Partner[] | ((prevData: Partner[]) => Partner[])) => {
    if (typeof value === 'function') {
      updateCurrentState({ partners: value(getCurrentState().partners) });
    } else {
      updateCurrentState({ partners: value });
    }
  };

  useEffect(() => {
    if (!batchId) return;

    const interval = setInterval(async () => {
      try {
        const endpoint = isFetchParent ? 'pull_batch_status' : 'batch_status';
        const response = await fetch(`${API_URL}/api/${endpoint}?batch_id=${batchId}`, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        const data: BatchStatusResponse = await response.json();

        if (data.status === 'success') {
          setPartners(prevData =>
            prevData.map(row => {
              const partnerStatus = isFetchParent
                ? data.parents?.[row.selectedReturn]
                : data.partners?.[row.selectedReturn];
              if (!partnerStatus) return row;

              let displayStatus = partnerStatus.status.toLowerCase();
              if (displayStatus === 'pending') displayStatus = 'pending';
              if (displayStatus === 'processing') displayStatus = 'processing';
              if (displayStatus === 'complete') displayStatus = 'completed';
              if (displayStatus === 'error') displayStatus = 'error';

              return {
                ...row,
                status: displayStatus,
                statusMessage: partnerStatus.message
              };
            })
          );

          const statuses = isFetchParent ? data.parents : data.partners;

          if (statuses) {
            if (statuses.BATCH.status === 'Complete') {
              setBatchId(null);
              setIsProcessing(false);
              addStatusMessage("Processing completed.");
              if (showHistory) {
                fetchFlowHistory();
              }
            }
          }
        }
      } catch (error) {
        console.error('Error checking batch status:', error);
        addStatusMessage(`Error checking status: ${error instanceof Error ? error.message : 'Unknown error'}`);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [batchId, isFetchParent]);

  // Add this useEffect for auto-scrolling status updates
  useEffect(() => {
    if (statusBoxRef.current) {
      const scrollToBottom = () => {
        if (statusBoxRef.current) {
          statusBoxRef.current.scrollTop = statusBoxRef.current.scrollHeight;
        }
      };

      // Scroll immediately
      scrollToBottom();

      // Scroll after a short delay to ensure content is rendered
      const timeoutId = setTimeout(scrollToBottom, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [status]);



  const childReturnVersion = isFetchParent ? parentModeState.childReturnVersion : '';

  const childOutputVersion = isFetchParent ? parentModeState.childOutputVersion : 'Same';
  // const setChildOutputVersion = (value: string) => updateCurrentState({ childOutputVersion: value });

  // const childReturnOptions = isFetchParent ? parentModeState.childReturnOptions : [];
  const setChildReturnOptions = (value: string[]) => updateCurrentState({ childReturnOptions: value });

  const handleSelectChange = (index: number, value: string) => {
    setPartners((prevData: Partner[]) => {
      const newData = [...prevData];
      newData[index].selectedReturn = value;
      return newData;
    });
  };
  const token: string = getFromLS("token") ?? "";
  const getCurrentState = () => parentModeState;
  const partners = getCurrentState().partners;


  const partnershipInfo = getCurrentState().partnershipInfo;
  const setPartnershipInfo = (value: PartnershipInfo) => updateCurrentState({ partnershipInfo: value });
  const selectedReturn = '';

  const statusBoxRef = useRef<HTMLDivElement>(null);


  const addStatusMessage = (message: string) => {
    setStatus(prevMessages => [...prevMessages, message]);
  };

  const maskSSN = (ssn: string) => {
    if (typeof ssn === 'string') {
      return '***-**-' + ssn.slice(-4);
    }
    return ssn;
  };

  const handleFlowData = async () => {
    const selectedRows = partners.filter(row => row.selected);
    if (selectedRows.length === 0) {
      addStatusMessage("Please select at least one entity to flow data to.");
      return;
    }

    if (isFetchParent && !childReturnVersion) {
      addStatusMessage("Please select a child return version.");
      return;
    }

    setIsProcessing(true);
    addStatusMessage("Starting data flow process...");

    try {
      if (isFetchParent) {
        // Pull mode - using new APIs
        const selectedParents = selectedRows.map(row => row.selectedReturn);
        const outputVersion = childOutputVersion === "Same" ? "" : childOutputVersion;

        const requestData = {
          ChildReturnID: childReturnVersion,
          SelectedParents: selectedParents,
          OutputVersion: outputVersion
        };

        console.log('Submitting pull batch with data:', requestData);
        console.log('Pull batch request URL:', `${API_URL}/api/submit_pull_batch`);

        const response = await fetch(`${API_URL}/api/submit_pull_batch`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(requestData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Pull batch submission response:', result);

        if (result.status === 'success') {
          setBatchId(result.batch_id);
          addStatusMessage("Pull batch submitted successfully. Processing started...");

          setPartners(prevData =>
            prevData.map(row => ({
              ...row,
              status: row.selected ? 'processing' : row.status
            }))
          );

          // Reload flow history after a short delay
          setTimeout(() => {
            if (showHistory) {
              fetchFlowHistory();
            }
          }, 2000);
        } else {
          throw new Error(result.message || 'Failed to submit pull batch');
        }
      } else {
        // Push mode - using existing APIs
        const selectedPartners = selectedRows.map(row => row.selectedReturn);
        const outputVersions = selectedRows.map(row => row.selectedOutputVersion);

        console.log('Submitting push batch with data:', {
          PartnershipReturnID: partnershipInfo.returnId,
          SelectedPartners: selectedPartners,
          OutputVersions: outputVersions
        });

        const response = await fetch(`${API_URL}/api/submit_batch`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            PartnershipReturnID: partnershipInfo.returnId,
            SelectedPartners: selectedPartners,
            OutputVersions: outputVersions
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Push batch submission response:', result);

        if (result.status === 'success') {
          setBatchId(result.batch_id);
          addStatusMessage("Push batch submitted successfully. Processing started...");

          setPartners(prevData =>
            prevData.map(row => ({
              ...row,
              status: row.selected ? 'processing' : row.status
            }))
          );

          // Reload flow history after a short delay
          setTimeout(() => {
            if (showHistory) {
              fetchFlowHistory();
            }
          }, 2000);
        } else {
          throw new Error(result.message || 'Failed to submit push batch');
        }
      }
    } catch (error) {
      console.error('Error submitting batch:', error);
      addStatusMessage(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
      setIsProcessing(false);
    }
  };

  const fetchFlowHistory = async () => {
    setIsLoadingHistory(true);
    try {
      const params = new URLSearchParams();
      if (ein) {
        if (isFetchParent) {
          params.append('partner_ssn', ein)
        } else {
          params.append('partnership_ein', ein);
        }
      }

      params.append('max_results', '10'); // Default to 10 results

      console.log('Fetching flow history with params:', params.toString());

      const response = await fetch(`${API_URL}/api/flow_history?${params.toString()}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include',
        cache: 'no-store',
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: FlowHistoryResponse = await response.json();
      console.log('Flow history response:', data);

      if (data.status === 'success') {
        setHistory(data.data);
      } else {
        throw new Error('Failed to fetch history');
      }
    } catch (error) {
      console.error('Error fetching history:', error);
      addStatusMessage(`Error fetching history: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setIsLoadingHistory(false);
    }
  };

  const handleGetTableData = async () => {

    addStatusMessage("Loading partnership data...");
    setPartners([]);


    setRefreshGrid(true);

    // Add retry logic for the table data request
    let tableResponse: Response | undefined;
    let responseText: string | null = null;

    const url = `${BACKEND_URL}/tax/internalk1/returns/parent/${selectedParent?.ClientMasterId}/${selectedParent?.ParentClientMasterId}/`;

    tableResponse = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      credentials: 'include',
      cache: 'no-store',
      mode: 'cors'
    });


    if (!tableResponse) {
      throw new Error('Failed to get response after retries');
    }

    if (!tableResponse.ok) {
      // Use the stored response text if available, otherwise read it again
      const errorText = responseText || await tableResponse.text();
      throw new Error(`Failed to fetch table data after retries: ${errorText}`);
    }

    const data = await tableResponse.json();    
    setParentReturnIds(data.data)
    setKey(data.data.length);
    setRefreshGrid(false);
  };

  // Format timestamp for display
  const formatTimestamp = (timestamp: string) => {
    const localTime = dayjs(timestamp).local();
    return localTime.format('MM/DD/YYYY hh:mm:ss A');
  };

  const handleReturnIdSelection = (selectedRows: any[]) => {
    if (selectedRows.length > 0) {
      const selectedReturnId = selectedRows[0]?.ReturnId;
      setSelectedReturnId(selectedReturnId)
    } else {
      setSelectedReturnId(null)
    }
  };
  
  const onSelectReturnId = () => {
    if (selectedReturnId) {
      onSelectComplete(selectedReturnId);
      onHide();
    }
  }

  return (
    <>
      <div
        className={styles.modaloverlay}
      />
      <Modal
        show={show}
        onHide={() => onHide()}
        size="lg"
        backdrop="static"
        centered
        className={styles.pullModal}
        contentClassName={styles.pullModalContent}
      >
        <Modal.Header className={styles.pullModalHeader}>
          <h4 className={styles.header}>Select Return Id for {selectedParent?.SourceName}</h4>
          <button
            type="button"
            className={styles.closeButton}
            onClick={() => {
              onHide();
            }}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className={styles.pullModalBody}>
          <>
            <Row className='no-gutter'>
              <Col md={12}>
                <div className={styles.integrationWorkflow}>
                  <div style={gridStyle}>                    
                    <CygnusGrid
                      key={key}
                      ref={gridRef}
                      columnDefs={columnDefs}
                      fetchData={async () => {
                        // Since this is not paginated, just return everything
                        return { records: parentReturnIds, totalCount: parentReturnIds.length };
                      }}
                      dataIdentifier="DocumentId"
                      rowSelection={"multiple"}
                      onLoadingChange={setRefreshGrid}
                      cachedIsLoading={refreshGrid}
                      cachedData={parentReturnIds}
                      setCachedData={setParentReturnIds}
                      onSelectionChange={handleReturnIdSelection}
                      gridOptions={{
                        rowSelection: {
                          mode: 'singleRow',
                          checkboxes: true,                 
                          // headerCheckbox: false,            // no “select all” (single select)
                          hideDisabledCheckboxes: false,    // show disabled boxes if not selectable
                          enableClickSelection: true,
                          isRowSelectable: (node:any)=> node?.data?.k1Type !== 'External',
                        },
                        selectionColumnDef: { pinned: 'left', width: 48 },
                        onModelUpdated: (params) => {
                          params.api.forEachNode((node) => {                            
                            if (selectedParent && node.data?.ReturnId === selectedReturnIdFromInternalK1[selectedParent?.DocumentId]) {
                              node.setSelected(true);
                            }
                          });
                        }
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="d-flex justify-content-end" style={{ marginRight: "-5px" }}>
                  <CustomButton
                    progress={false}
                    onclick={() => onSelectReturnId()}
                    content={"OK"}
                  />
                </div>
                
              </Col>
            </Row>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InternalK1PullDataModal;